import { Dropdown } from '@/design-system/components/dropdown';
import { UniCheckbox } from '@/design-system/components/inputs/uniCheckbox';
import { UniInput } from '@/design-system/components/inputs/UniInput';
import { H5 } from '@/design-system/components/typography';
import { LayoutContext } from 'contexts/LayoutContext';
import { View, SxProp } from 'dripsy';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

interface AllOffersTitleProps {
  onSearch: (value?: string) => void;
  sx?: SxProp;
  showAssets: {
    showMyAssetsOnly: boolean;
    toggleShowMyAssetsOnly: () => void;
  };
}

export const AllOffersWebTitle: React.FC<AllOffersTitleProps> = ({ sx, onSearch, showAssets }) => {
  const { t } = useTranslation();
  const layout = useContext(LayoutContext);
  const isVertical = layout.isVertical;
  const style = isVertical ? styles.containerVertical : styles.containerHorizontal;

  return (
    <View sx={{ ...style, ...sx }}>
      <View sx={styles.containerLeft}>
        <H5 bold>{t('earn-invest::glossary.all-offers')}</H5>
      </View>
      <View sx={styles.containterRight}>
        <UniCheckbox
          sx={{ flex: 1 }}
          label={t('earn-invest::glossary.show-my-asset-only')}
          value={showAssets.showMyAssetsOnly}
          onValueChange={showAssets.toggleShowMyAssetsOnly}
          verticalAlignCenter
        />
        <UniInput
          size="default"
          prefixIcon="search"
          onValueChange={onSearch}
          placeholder={t('earn-invest::glossary.search-by-asset')}
          wrapperSx={{ flex: 1, maxWidth: '100%', minWidth: 250 }}
        />
      </View>
    </View>
  );
};

enum StyleName {
  containerHorizontal = 'containerHorizontal',
  containerVertical = 'containerVertical',
  containerLeft = 'containerLeft',
  containterRight = 'containterRight',
  assetSelector = 'assetSelector'
}

const styles: Record<StyleName, SxProp> = {
  containerHorizontal: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  containerVertical: {},
  containerLeft: {},
  containterRight: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '$3',
    flexWrap: 'wrap'
  },
  assetSelector: {}
};
